import { IConstraint, INumberConstraint, IStringConstraint, ITimespanConstraint } from './annotation';
import { UniqueModelNameValidator } from './unique-model-name-validator';
import {
    WholeNumberValidator,
    RequiredValidator,
    OccursValidator,
    MinMaxValidator,
    PatternValidator,
    AllowedValidator,
    TimespanValidator
} from './validators';
import { IAttributeValidator, UniqueCaseSensitiveValidator, UniqueValidator } from 'shell-models-lib';

export class Validators {
    private constructor() { }

    public static validatorsFor(constraint: IConstraint): IAttributeValidator[] {
        const validators: IAttributeValidator[] = [];
        if (constraint.required) {
            validators.push(RequiredValidator.INSTANCE);
        }

        if (constraint.maxOccurs || constraint.minOccurs) {
            validators.push(OccursValidator.INSTANCE);
        }

        if (constraint.unique) {
            validators.push(UniqueValidator.INSTANCE);
        }

        if (constraint.uniqueCaseSensitive) {
            validators.push(UniqueCaseSensitiveValidator.INSTANCE);
        }

        if (constraint.uniqueModelName) {
            validators.push(UniqueModelNameValidator.INSTANCE);
        }

        const tConstraint = constraint as ITimespanConstraint;
        if (tConstraint.minimum_timespan !== undefined || tConstraint.maximum_timespan !== undefined) {
            validators.push(TimespanValidator.INSTANCE);
        }

        const nConstraint = constraint as INumberConstraint;
        if (nConstraint.whole) {
            validators.push(WholeNumberValidator.INSTANCE);
        }

        if (nConstraint.minimum !== undefined || nConstraint.maximum !== undefined) {
            validators.push(MinMaxValidator.INSTANCE);
        }

        const sConstraint = constraint as IStringConstraint;
        if (sConstraint.pattern || sConstraint.patterns) {
            validators.push(PatternValidator.INSTANCE);
        }

        if (sConstraint.allowed) {
            validators.push(AllowedValidator.INSTANCE);
        }

        return validators;
    }
}
